// API Configuration - WEBSITE
// Environment variables from Vite (import.meta.env)

export const config = {
  // API URLs
  apiUrl: import.meta.env.VITE_API_URL || 'https://backend.localhost/api',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://backend.localhost',

  // Frontend URLs
  userAppUrl: import.meta.env.VITE_USER_APP_URL || 'https://app.localhost',
  adminAppUrl: import.meta.env.VITE_ADMIN_APP_URL || 'https://admin.localhost',
  websiteUrl: import.meta.env.VITE_WEBSITE_URL || 'https://localhost',

  // Environment
  env: import.meta.env.VITE_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // App settings
  appName: 'CaninCloud Website',
  appVersion: '2.0.0'
};

export default config;
